var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookCircleFill = function SvgFacebookCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3a9 9 0 0 0-1.406 17.891v-6.29H8.308V12h2.286v-1.983c0-2.255 1.343-3.5 3.4-3.5.984 0 2.014.175 2.014.175v2.214h-1.134c-1.119 0-1.467.694-1.467 1.406V12h2.495l-.398 2.601h-2.097v6.29A9 9 0 0 0 12 3"
  })));
};
export default SvgFacebookCircleFill;